import React, { Component } from 'react'
import { connect } from 'react-redux'
import { showSideBar } from '../../../redux/actions/miscActions'
import ProductOverview from '../ulits/ProductOverview'
import { Tabs } from 'antd';
import SearchBar from '../../layout/SearchBar'

const { TabPane } = Tabs;

export class Products extends Component {
  
  
  showNewProductForm=()=>{
    this.props.showSideBar('newProductForm')
  }

  render() {
    const { allClientProducts } = this.props.products
    const { searchValue } = this.props.shop;
    const groentenProducten = allClientProducts.filter(x => x.productCategorie === 'groenten').filter((x) => x.productNaam.toLowerCase().includes(searchValue.toLowerCase())).sort((a, b) =>
    a.productNaam > b.productNaam
    ? 1
    : b.productNaam > a.productNaam
    ? -1
    : 0
    )
    
    const fruitProducten = allClientProducts.filter(x => x.productCategorie === 'fruit').filter((x) => x.productNaam.toLowerCase().includes(searchValue.toLowerCase())).sort((a, b) =>
    a.productNaam > b.productNaam
      ? 1
      : b.productNaam > a.productNaam
      ? -1
      : 0
  )

    const sappenProducten = allClientProducts.filter(x => x.productCategorie === 'sap').filter((x) => x.productNaam.toLowerCase().includes(searchValue.toLowerCase())).sort((a, b) =>
    a.productNaam > b.productNaam
      ? 1
      : b.productNaam > a.productNaam
      ? -1
      : 0
  )

    const aardvruchtenProducten = allClientProducts.filter(x => x.productCategorie === 'aardvrucht').filter((x) => x.productNaam.toLowerCase().includes(searchValue.toLowerCase())).sort((a, b) =>
    a.productNaam > b.productNaam
      ? 1
      : b.productNaam > a.productNaam
      ? -1
      : 0
  )

    const specerijenProducten = allClientProducts.filter(x => x.productCategorie === 'specerijen').filter((x) => x.productNaam.toLowerCase().includes(searchValue.toLowerCase())).sort((a, b) =>
    a.productNaam > b.productNaam
      ? 1
      : b.productNaam > a.productNaam
      ? -1
      : 0
  )

    const pakkettenProducten = allClientProducts.filter(x => x.productCategorie === 'pakketten').filter((x) => x.productNaam.toLowerCase().includes(searchValue.toLowerCase())).sort((a, b) =>
    a.productNaam > b.productNaam
      ? 1
      : b.productNaam > a.productNaam
      ? -1
      : 0
  )

    return (
      <div className="admin-product-page">
        <div className="header">
        <SearchBar />
        <button onClick={this.showNewProductForm} className="small-main-btn">New product</button>
        </div>
        <Tabs defaultActiveKey='groenten'>
      <TabPane tab='Groenten' key="groenten" >
        <ProductOverview products={groentenProducten} />
      </TabPane>
      <TabPane tab='Fruit' key="fruit" >
        <ProductOverview products={fruitProducten} />
      </TabPane>
      <TabPane tab='Sappen' key="sappen" >
        <ProductOverview products={sappenProducten} />
      </TabPane>
      <TabPane tab='Aardvruchten' key="aardvruchten" >
        <ProductOverview products={aardvruchtenProducten} />
      </TabPane>
      <TabPane tab='Specerijen' key="specerijen" >
        <ProductOverview products={specerijenProducten} />
      </TabPane>
      <TabPane tab='Pakketten' key="pakketten" >
        <ProductOverview products={pakkettenProducten} />
      </TabPane>

        </Tabs>
      </div>
    )
  }
}

const mapStateToProps =(state)=>({  
  products: state.products,
  shop: state.shop
})

export default connect(mapStateToProps, { showSideBar })(Products)
